import React, {useContext} from 'react';
import {useOverlay} from "@/OverlayContext";
import {useTranslation} from "react-i18next";
import InventoryList from "@/components/game/InventoryList";
import {SettingsContext} from "@/SettingsContext";
import {showMultiLingualText} from "@/utils/LanguageUtils";

const InventoryButton = React.memo(function InventoryButton() {

    const { setOverlay, setOverlayIsVisible } = useOverlay();
    const { t } = useTranslation();

    const { tourSettings } = useContext(SettingsContext);

    // game module inventory
    function showInventory() {
        setOverlay(
            <InventoryList onContentLoaded={() => {
                setOverlayIsVisible(true);
            }} />
        )
    }

    return (
        <div>

            {tourSettings.id &&
                <div className="flex">
                    <div className=" flex w-12 h-12 items-center">
                        { tourSettings?.game?.inventory_icon &&
                            <img src={tourSettings.game.inventory_icon?.preview_url} alt={ showMultiLingualText(tourSettings.game.inventory_title, t('game.inventory')) }  onClick={showInventory} className="w-full h-full object-cover cursor-pointer" />
                        }
                        { !tourSettings?.game?.inventory_icon &&
                            <div
                                className="rounded-full p-3 hover:cursor-pointer flex flex-col text-sm items-center ml-4"
                                style={{"background": (tourSettings?.header_background_contrast_color) ? tourSettings.header_background_contrast_color : '#f3f4f6'}}
                                onClick={showInventory}>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                        d="M21 12a2.25 2.25 0 0 0-2.25-2.25H15a3 3 0 1 1-6 0H5.25A2.25 2.25 0 0 0 3 12m18 0v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 9m18 0V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v3"/>
                                </svg>
                            </div>
                        }
                    </div>
                </div>
            }

        </div>
    );
});

export default InventoryButton;